var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReturns = function SvgReturns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 24,
    r: 12,
    fill: "#00C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005269",
    d: "M15.503 37.982v4.216a1 1 0 0 0 1.516.857l8.602-5.177a1 1 0 0 0 .045-1.685l-8.602-5.823a1 1 0 0 0-1.56.828v4.78C7.953 35.474 2 29.378 2 21.951c0-2.46.652-4.823 1.876-6.918a1 1 0 0 0-1.727-1.01A15.647 15.647 0 0 0 0 21.952c0 8.543 6.86 15.522 15.503 16.031zm2-.8a1.006 1.006 0 0 0 0-.34v-3.76l5.745 3.89-5.745 3.457v-3.246zM16.24 5.89V1.002a1 1 0 0 0-1.56-.828L6.078 5.997a1 1 0 0 0 .045 1.685l8.602 5.177a1 1 0 0 0 1.515-.857V7.89l.279-.003c8.024 0 14.52 6.304 14.52 14.063 0 1.96-.417 3.866-1.211 5.628a1 1 0 1 0 1.823.822 15.655 15.655 0 0 0 1.387-6.45c0-8.877-7.404-16.063-16.52-16.063-.092 0-.185 0-.278.002zm-2-3.004v7.347L8.495 6.776l5.745-3.89z"
  })))));
};
export default SvgReturns;